export default {
  state: {
    adminList: [],
    adminListUsers: [],
    adminListContragents: [],
    adminListDebtStatuses: [],
    adminListPhoneTypes: [],
    adminListAddressTypes: [],
    adminListContactfaceTypes: [],
    adminListCallStatuses: [],
    adminListCallTypes: [],
    adminListDepartureStatuses: [],
    adminListRoles: [],
    adminListTeams: [],
    adminListRegistryDates: [],
    adminPermissions: [],
  },
  mutations: {
    SET_ADMIN_LIST_USERS(state, payload) {
      state.adminListUsers = payload.users;
    },
    SET_ADMIN_LIST_CONTRAGENTS(state, payload) {
      state.adminListContragents = payload.contragents;
    },
    SET_ADMIN_LIST_DEBT_STATUSES(state, payload) {
      state.adminListDebtStatuses = payload.statuses;
    },
    SET_ADMIN_LIST_PHONE_TYPES(state, payload) {
      state.adminListPhoneTypes = payload.types;
    },
    SET_ADMIN_LIST_ADDRESS_TYPES(state, payload) {
      state.adminListAddressTypes = payload.types;
    },
    SET_ADMIN_LIST_CONTACTFACE_TYPES(state, payload) {
      state.adminListContactfaceTypes = payload.types;
    },
    SET_ADMIN_LIST_CALL_STATUSES(state, payload) {
      state.adminListCallStatuses = payload.statuses;
    },
    SET_ADMIN_LIST_CALL_TYPES(state, payload) {
      state.adminListCallTypes = payload.types;
    },
    SET_ADMIN_LIST_DEPARTURE_STATUSES(state, payload) {
      state.adminListDepartureStatuses = payload.statuses;
    },
    SET_ADMIN_LIST_ROLES(state, payload) {
      state.adminListRoles = payload.roles;
    },
    SET_ADMIN_LIST_TEAMS(state, payload) {
      state.adminListTeams = payload.teams;
    },
    SET_ADMIN_LIST_REGISTRY_DATES(state, payload) {
      state.adminListRegistryDates = payload.registry_dates;
    },
    SET_ADMIN_PERMISSIONS(state, payload) {
      state.adminPermissions = payload.permissions;
    },
  },
  actions: {
    async GET_ADMIN_LIST_USERS({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/users');
        commit('SET_ADMIN_LIST_USERS', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_CONTRAGENTS({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/contragents');
        commit('SET_ADMIN_LIST_CONTRAGENTS', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_DEBT_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/debt/statuses');
        commit('SET_ADMIN_LIST_DEBT_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_PHONE_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/phone/types');
        commit('SET_ADMIN_LIST_PHONE_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_ADDRESS_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/address/types');
        commit('SET_ADMIN_LIST_ADDRESS_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_CONTACTFACE_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/contactface/types');
        commit('SET_ADMIN_LIST_CONTACTFACE_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_CALL_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/call/statuses');
        commit('SET_ADMIN_LIST_CALL_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },

    async GET_ADMIN_LIST_CALL_TYPES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/call/types');
        commit('SET_ADMIN_LIST_CALL_TYPES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_DEPARTURE_STATUSES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/departure/statuses');
        commit('SET_ADMIN_LIST_DEPARTURE_STATUSES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_ROLES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/roles');
        commit('SET_ADMIN_LIST_ROLES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_TEAMS({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/teams');
        commit('SET_ADMIN_LIST_TEAMS', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_LIST_REGISTRY_DATES({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/list/registrydates');
        commit('SET_ADMIN_LIST_REGISTRY_DATES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_ADMIN_PERMISSIONS({ commit }) {
      try {
        const { data } = await window.axios.get('/admin/permissions');
        commit('SET_ADMIN_PERMISSIONS', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    adminListUsers(state) {
      return state.adminListUsers;
    },
    adminListContragents(state) {
      return state.adminListContragents;
    },
    adminListPhoneTypes(state) {
      return state.adminListPhoneTypes;
    },
    adminListAddressTypes(state) {
      return state.adminListAddressTypes;
    },
    adminListDebtStatuses(state) {
      return state.adminListDebtStatuses;
    },
    adminListContactfaceTypes(state) {
      return state.adminListContactfaceTypes;
    },
    adminListCallStatuses(state) {
      return state.adminListCallStatuses;
    },
    adminListCallTypes(state) {
      return state.adminListCallTypes;
    },
    adminListDepartureStatuses(state) {
      return state.adminListDepartureStatuses;
    },
    adminListRoles(state) {
      return state.adminListRoles;
    },
    adminListTeams(state) {
      return state.adminListTeams;
    },
    adminListRegistryDates(state) {
      return state.adminListRegistryDates;
    },
    adminPermissions(state) {
      return state.adminPermissions;
    },
  },
};
